import {onLCP, onINP, onCLS, onTTFB, onFCP} from 'web-vitals';

const ENDPOINT = `${(window as any).appContext || ''}/api/metrics`;
const FLUSH_DELAY_MS = 5_000;

interface BufferedMetric {
    name: string;
    value: number;
    route: string;
}

const buffer: BufferedMetric[] = [];
let timer: ReturnType<typeof setTimeout> | undefined;

function flush() {
    clearTimeout(timer);
    timer = undefined;
    const entries = buffer.splice(0);
    if (entries.length === 0) return;
    const payload = new Blob([JSON.stringify(entries)], {type: 'application/json'});
    try {
        if (typeof navigator.sendBeacon === 'function') {
            navigator.sendBeacon(ENDPOINT, payload);
        } else {
            fetch(ENDPOINT, {method: 'POST', body: payload, keepalive: true}).catch(() => {});
        }
    } catch {
        // best-effort; never block the UI
    }
}

function scheduleFlush() {
    if (!timer) {
        timer = setTimeout(flush, FLUSH_DELAY_MS);
    }
}

function reportMetric(name: string, value: number) {
    buffer.push({name, value, route: window.location.pathname});
    scheduleFlush();
}

document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
});

onLCP((metric) => reportMetric('lcp', metric.value));
onINP((metric) => reportMetric('inp', metric.value));
onCLS((metric) => reportMetric('cls', metric.value));
onTTFB((metric) => reportMetric('ttfb', metric.value));
onFCP((metric) => reportMetric('fcp', metric.value));
